module.exports = __webpack_public_path__ + "static/media/RO.c08877bf.png";